var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "canvasContainer"
    }
  }, [_c('svg', {
    attrs: {
      "width": _vm.floorplan.width + 'px',
      "height": _vm.floorplan.height + 'px'
    }
  }, [_c('image', {
    attrs: {
      "xlink:href": _vm.floorplan.data,
      "x": "0",
      "y": "0",
      "width": _vm.floorplan.width,
      "height": _vm.floorplan.height
    },
    on: {
      "click": _vm.floorplan_clicked
    }
  }), _vm._v(" "), _vm._l((_vm.issues), function(issue) {
    return _c('g', {
      staticClass: "marker",
      attrs: {
        "stroke-width": "3",
        "stroke": "red"
      },
      on: {
        "click": function($event) {
          _vm.marker_clicked(issue)
        }
      }
    }, [_c('line', {
      attrs: {
        "x1": issue.loc_x - 10,
        "x2": issue.loc_x + 10,
        "y1": issue.loc_y - 10,
        "y2": issue.loc_y + 10
      }
    }), _vm._v(" "), _c('line', {
      attrs: {
        "x1": issue.loc_x - 10,
        "x2": issue.loc_x + 10,
        "y1": issue.loc_y + 10,
        "y2": issue.loc_y - 10
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": issue.loc_x - 15,
        "y": issue.loc_y - 15,
        "width": "30",
        "height": "30",
        "stroke": "rgba(0, 0, 0, 0)",
        "fill": "rgba(0, 0, 0, 0)"
      }
    })])
  })], 2)]), _vm._v(" "), _c('modal', {
    on: {
      "hide": _vm.clear_issue
    },
    model: {
      value: (_vm.issue_modal_open),
      callback: function($$v) {
        _vm.issue_modal_open = $$v
      },
      expression: "issue_modal_open"
    }
  }, [(_vm.selected_issue != null && _vm.selected_issue.id != null) ? _c('span', {
    slot: "title"
  }, [_vm._v("Update Issue")]) : _c('span', {
    slot: "title"
  }, [_vm._v("New Issue")]), _vm._v(" "), (_vm.selected_issue != null) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label",
    attrs: {
      "for": "show-type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_issue.type),
      expression: "selected_issue.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "show-type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected_issue.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.issue_types), function(it) {
    return _c('option', {
      domProps: {
        "value": it.id
      }
    }, [_vm._v(_vm._s(it.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label",
    attrs: {
      "for": "show-desc"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_issue.description),
      expression: "selected_issue.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "show-desc",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.selected_issue.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected_issue.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label",
    attrs: {
      "for": "show-image"
    }
  }, [_vm._v("File")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    ref: "image_input",
    staticClass: "zUploadBtn form-control",
    attrs: {
      "id": "show-image",
      "type": "file",
      "placeholder": "Browse...",
      "accept": "image/*",
      "multiple": ""
    }
  })])]), _vm._v(" "), (_vm.selected_issue_photos.length >= 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('ul', _vm._l((_vm.selected_issue_photos), function(photo) {
    return _c('li', {
      staticStyle: {
        "list-style-type": "none"
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-remove-sign text-danger clickable",
      on: {
        "click": function($event) {
          _vm.delete_photo(photo)
        }
      }
    }), _vm._v("\n            " + _vm._s(photo.file_name) + "\n          ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.upload_progress.length) ? _c('div', {
    staticClass: "form-group progressBars"
  }, _vm._l((_vm.upload_progress), function(progress) {
    return _c('progress-bar', {
      key: progress.id,
      attrs: {
        "type": "success",
        "striped": true,
        "active": true
      },
      model: {
        value: (progress.percent),
        callback: function($$v) {
          progress.percent = $$v
        },
        expression: "progress.percent"
      }
    })
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [(_vm.selected_issue != null && _vm.selected_issue.id != null) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.delete_issue
    }
  }, [_vm._v("Delete "), _c('i', {
    staticClass: "glyphicon glyphicon-trash"
  })]) : _vm._e(), _vm._v(" "), (_vm.selected_issue != null && _vm.selected_issue.id != null) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.update_issue
    }
  }, [_vm._v("Update issue "), _c('i', {
    staticClass: "glyphicon glyphicon-pencil"
  })]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.add_issue
    }
  }, [_vm._v("Add issue "), _c('i', {
    staticClass: "glyphicon glyphicon-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        _vm.issue_modal_open = false
      }
    }
  }, [_vm._v("Dismiss "), _c('i', {
    staticClass: "glyphicon glyphicon-remove"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.urgency
    }
  }, [_vm._v("Continue "), _c('i', {
    staticClass: "glyphicon glyphicon-share-alt"
  })])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "hidden-xs pull-right",
    attrs: {
      "src": "/static/imgs/logo.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Issue Marker")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "showMsg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n      Shown below is the floorplan for your store. Click anywhere on the floorplan to mark an issue, or click an existing issue to make changes.")]), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-835db514","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/logger/Logger.vue
// module id = 510
// module chunks = 0